
// * spid-idps.js *
// This script populate the SPID button with a remote json or the `idps` var content
//var queryURL = "js/JSON_IDP_list_EXAMPLE.json";
var queryURL = "https://registry.spid.gov.it/entities-idp?&output=json&custom=info_display_base";

// Entity ID to Keycloak alias mapping (matches keycloak-spid-only login.ftl spidprovidermatch).
// Alias names are generated by the Keycloak SPID provider configuration client
// (keycloak/keycloak-spid-provider-configuration-client) as "spid-" + slugified entity name.
var entityIdToAlias = {
  "https://loginspid.aruba.it": "spid-aruba",
  "https://id.eht.eu": "spid-etnahitech",
  "https://loginspid.infocamere.it": "spid-infocamere",
  "https://identity.infocert.it": "spid-infocert",
  "https://idp.intesigroup.com": "spid-intesi-group",
  "https://spid.intesa.it": "spid-intesi-group",
  "https://id.lepida.it/idp/shibboleth": "spid-lepida",
  "https://idp.namirialtsp.com/idp": "spid-namirial",
  "https://posteid.poste.it": "spid-poste",
  "https://identity.sieltecloud.it": "spid-sielte",
  "https://spid.register.it": "spid-register.it",
  "https://login.id.tim.it/affwebservices/public/saml2sso": "spid-tim",
  "https://spid.teamsystem.com/idp": "spid-teamsystem",
  "https://demo.spid.gov.it": "spid-demo",
  "https://validator.spid.gov.it": "spid-validator"
};
var idps = [{"organization_name": "ArubaPEC S.p.A.", "entity_id": "https://loginspid.aruba.it", "logo_uri": "assets/spid/img/spid-idp-arubaid.svg"},{"organization_name": "EtnaHitech S.C.p.A.", "entity_id": "https://id.eht.eu", "logo_uri": "assets/spid/img/spid-idp-etnaid.svg"},{"organization_name": "InfoCamere S.C.p.A.", "entity_id": "https://loginspid.infocamere.it", "logo_uri": "assets/spid/img/spid-idp-infocamereid.svg"},{"organization_name": "InfoCert S.p.A.", "entity_id": "https://identity.infocert.it", "logo_uri": "assets/spid/img/spid-idp-infocertid.svg"},{"organization_name": "IN.TE.S.A. S.p.A.", "entity_id": "https://spid.intesa.it", "logo_uri": "assets/spid/img/spid-idp-intesaid.svg"},{"organization_name": "Lepida S.p.A.", "entity_id": "https://id.lepida.it/idp/shibboleth", "logo_uri": "assets/spid/img/spid-idp-lepidaid.svg"},{"organization_name": "Namirial", "entity_id": "https://idp.namirialtsp.com/idp", "logo_uri": "assets/spid/img/spid-idp-namirialid.svg"},{"organization_name": "Poste Italiane SpA", "entity_id": "https://posteid.poste.it", "logo_uri": "assets/spid/img/spid-idp-posteid.svg"},{"organization_name": "Sielte S.p.A.", "entity_id": "https://identity.sieltecloud.it", "logo_uri": "assets/spid/img/spid-idp-sielteid.svg"},{"organization_name": "Register.it S.p.A.", "entity_id": "https://spid.register.it", "logo_uri": "assets/spid/img/spid-idp-spiditalia.svg"},{"organization_name": "TI Trust Technologies srl", "entity_id": "https://login.id.tim.it/affwebservices/public/saml2sso", "logo_uri": "assets/spid/img/spid-idp-timid.svg"},{"organization_name": "TeamSystem s.p.a.", "entity_id": "https://spid.teamsystem.com/idp", "logo_uri": "assets/spid/img/spid-idp-teamsystemid.svg"}]

// Test/demo IdPs — always appended after the production list
var testIdps = [
  {"organization_name": "SPID Demo", "entity_id": "https://demo.spid.gov.it", "logo_uri": "assets/spid/img/spid-ico-circle-bb.svg"},
  {"organization_name": "SPID Validator", "entity_id": "https://validator.spid.gov.it", "logo_uri": "assets/spid/img/spid-ico-circle-bb.svg"}
]

// spid_populate function, if '.spid-button[data-spid-remote] ul' exist, try to get the remote json file and pupulate all spid buttons
function spid_populateEntries(entries, spid_elements) {
  entries = entries.sort(function() { return Math.random() - 0.5; });
  for (var u = 0; u < spid_elements.length; u++) {
    // Remove previously added IdP entries to avoid duplicates on re-populate
    var existing = spid_elements[u].querySelectorAll('li.spid-idp-button-link');
    for (var e = 0; e < existing.length; e++) { existing[e].remove(); }
    // Non-production: Validator in coda, provider reali shufflati, Demo in testa
    // (prepend inverte l'ordine: ultimo aggiunto = primo visualizzato)
    if (!window.__MENSA_PRODUCTION__) {
      var validator = testIdps.find(function(t) { return t.entity_id.indexOf('validator') !== -1; });
      if (validator) { spid_addIdpEntry(validator, spid_elements[u]); }
    }
    for (var i = 0; i < entries.length; i++) { spid_addIdpEntry(entries[i], spid_elements[u]); }
    if (!window.__MENSA_PRODUCTION__) {
      var demo = testIdps.find(function(t) { return t.entity_id.indexOf('demo') !== -1; });
      if (demo) { spid_addIdpEntry(demo, spid_elements[u]); }
    }
  }
}

function spid_populate() {
  let spid_elements = document.querySelectorAll('ul[data-spid-remote]')
  if (spid_elements.length > 0 ) {
    fetch(queryURL)
     .then(function (response) {
       return response.json();
      })
     .then(function (remoteIdps) {
       spid_populateEntries(remoteIdps, spid_elements);
      })
     .catch(function (error) {
      console.log('Error during fetch: ' + error.message);
      spid_populateEntries(idps, spid_elements);
     });
  }
}

// function spid_addIdpEntry make a "li" element with the ipd link and prepend this in a element
//
// options:
// - data - is an object with "organization_name", "entity_id" and "logo_uri" values
// - element - is the element where is added the new "li" element
function spid_addIdpEntry(data, element) {
  const att = document.createAttribute("data-idp");
  att.value = data['entity_id'];
  let li = document.createElement('li');
  li.className = 'spid-idp-button-link';
  li.setAttributeNode(att);
  if (element.id.indexOf('post')!== -1) {
    li.innerHTML = `<button class="idp-button-idp-logo" name="${data['organization_name']}" type="submit"><span class="spid-sr-only">${data['organization_name']}</span><img class="spid-idp-button-logo" src="${data['logo_uri']}" alt="${data['organization_name']}" /></button></li>`
  };  
  if (element.id.indexOf('get')!== -1) {
    var alias = entityIdToAlias[data['entity_id']];
    if (!alias) {
      console.warn('[SPID] No Keycloak alias found for entity_id:', data['entity_id']);
    }
    var onclick = alias
      ? "window.spidLogin('" + alias + "'); return false;"
      : "window.spidLogin(); return false;";
    var isTestIdp = testIdps && testIdps.some(function(t) { return t.entity_id === data['entity_id']; });
    var nameHtml = isTestIdp
      ? '<span class="spid-idp-button-name">' + data['organization_name'] + '</span>'
      : '<span class="spid-sr-only">' + data['organization_name'] + '</span>';
    li.innerHTML = `<a href="#" onclick="${onclick}">${nameHtml}<img src="${data['logo_uri']}" alt="${data['organization_name']}" /></a>`
  };
  element.prepend(li)
}

// Auto-populate disabled: called manually from Angular LoginComponent.ngAfterViewInit()
// document.onreadystatechange = function () {
//   if (document.readyState == "interactive") {
//     spid_populate()
//   }
// }

